export default __webpack_public_path__ + "static/media/zh-CN_Wall.65a2083b.png";